
import storyblokMeta from "@/mixins/storyblokMeta"
import { defineComponent } from "@nuxtjs/composition-api"
import storyblokService from "@/services/storyblok.service"
import { useStoryblokBridge } from "@storyblok/nuxt-2"

export default defineComponent({
    name: "CustomDomainRoute",
    meta: {
        toolbar: {
            hidden: true,
        },
        survey: {
            hidden: true,
        },
        hideBottomNav: true,
    },
    mixins: [storyblokMeta],
    async asyncData({ route, error, $config }) {
        const path = route.path.slice(1).replace("/", "-")

        const version =
            !$config.isProduction || route.query?._storyblok !== undefined
                ? "draft"
                : "published"
        const story = await storyblokService.getStory(path, version).catch(() =>
            error({
                statusCode: 404,
                message: "Seite nicht gefunden.",
            })
        )
        return { story }
    },
    mounted() {
        if (this.story?.id && this.$route.query?._storyblok !== undefined) {
            useStoryblokBridge(
                this.story.id,
                (evStory) => (this.story = evStory)
            )
        }
    },
})
